import { Module } from 'vuex';
import { IRootState } from '@/store';
import { IDocumentState } from './document.types';
import {
  IDocumentData,
  IDocumentRevisionData,
  IQuoteDocumentTagData
} from '@/models';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: IDocumentState = {
  version: 1,
  count: 0,
  documents: [] as IDocumentData[],
  documentRevisions: [] as IDocumentRevisionData[],
  documentTags: [] as IQuoteDocumentTagData[],
  lastPromise: null
};

const namespaced = true;

export const document: Module<IDocumentState, IRootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
